/**
 * Currencies with no minor unit, mirroring the API's CURRENCIES_TO_ZERO_DECIMALS.
 * Displaying "1 802 500,00 Ar" for an ariary amount reads as a rounding error.
 */
const ZERO_DECIMAL_CURRENCIES = [
    "BIF", "CLP", "DJF", "GNF", "JPY", "KMF", "KRW", "MGA",
    "PYG", "RWF", "UGX", "VND", "VUV", "XAF", "XOF", "XPF",
];

/**
 * Formats a monetary amount at the precision its currency actually supports.
 * @param {number} amount - Amount in base currency units
 * @param {string} currency - ISO 4217 code
 * @returns {string} Localized amount followed by the currency code
 */
export default function formatAmount(amount, currency) {
    const code = (currency || "").toUpperCase();
    const digits = ZERO_DECIMAL_CURRENCIES.includes(code) ? 0 : 2;
    const value = Number(amount) || 0;
    return `${value.toLocaleString("fr-FR", {
        minimumFractionDigits: digits,
        maximumFractionDigits: digits,
    })} ${code}`;
}
